import { render, staticRenderFns } from "./EmployeePositionHistoryTab.vue?vue&type=template&id=564ab410&scoped=true"
import script from "./EmployeePositionHistoryTab.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeePositionHistoryTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EmployeePositionHistoryTab.vue?vue&type=style&index=0&id=564ab410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564ab410",
  null
  
)

export default component.exports